import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"


const __default__ = {
  name: 'XLogo',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const cdn = process.env.VUE_APP_CDN;

return (_ctx: any,_cache: any) => {
  const _component_ot_logo = _resolveComponent("ot-logo")!

  return (_openBlock(), _createBlock(_component_ot_logo, _mergeProps(_ctx.$attrs, {
    cdn: _unref(cdn),
    class: "x-logo"
  }), null, 16, ["cdn"]))
}
}

})